import {
    StyleSheet
} from "react-native";
import type {
    PaginationLoadMoreDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    error: {
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        alignItems: "center"
    },
    count: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    spaces
}: PaginationLoadMoreDynamicStyleType) => {
    return {
        container: {
            gap: spaces.spacingSm
        },
        error: {
            gap: spaces.spacingXs
        }
    };
};
export default stylesheet;
